var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"about_us"},on:{"click":_vm.closeNav}},[_c('definition',{attrs:{"aboutInfo":_vm.aboutInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }